<template>
	<v-container fluid fill-height class="home-hero" style="max-height: 90vh">
		<!-- <v-row align-center justify-center fill-height> -->
		<v-row align="center" justify="center" fill-height>

			<v-col class="text-center headline">
				<h1 class="font-bold-black white--text keep-spaces elevation-15 pa-3">نرم افزارهای پازار، ساده و قدرتمند</h1>
			</v-col>
				<v-spacer class="hidden-md-and-down" ></v-spacer>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: "HomeHero",
	};
</script>

<style scoped>
	h1 {
		background: rgba(0, 0, 0, 0.3);
	}
	.keep-spaces {
		white-space: pre-wrap;
	}
	.home-hero {
		background: url("~@/assets/img/home-hero1.jpg");
		/* background: url('~@/assets/img/home-hero.png'); */
		background-size: cover;
		width: 100%;
		height: 100%;
	}
</style>
